import { View, Image, useColorScheme } from 'react-native';
import BusinessList from '../components/businessList';
import WebMap from '../components/webMap';
import BusinessListSearch from '../components/businessListSearch';
import FilterButton from '../components/filterButton';
import { useAppTheme } from '../theme';
import AddBusinessButton from '../components/addBusinessButton';
import DrawerButton from '../components/drawerButton';
import AddBusinessModal from '../components/addBusinessModal';
import EditBusinessModal from '../components/editBusinessModal';
import { useAppSelector } from '../redux/hooks';
import { useState } from 'react';
import CurrentLocationButton from '../components/currentLocationButton';

export default function WebMapScreen() {
  const theme = useAppTheme();
  const osTheme = useColorScheme();
  const { selectedBusiness } = useAppSelector((state) => state.businessList);

  // Shouldn't be saved in redux, nonserializable data
  const [webMap, setWebMap] = useState<google.maps.Map | null>(null);

  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <View
        style={{
          width: '25%',
          height: '100%',
          backgroundColor: theme.colors.background,
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <DrawerButton />
          <View style={{ width: '25%' }}>
            <Image
              source={
                osTheme === 'dark'
                  ? require('../assets/logo-dark.png')
                  : require('../assets/logo-light.png')
              }
              style={{
                width: 100,
                height: 50,
                resizeMode: 'contain',
              }}
            />
          </View>
        </View>
        {!selectedBusiness && (
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
              marginHorizontal: 12,
              marginTop: 16,
            }}
          >
            <BusinessListSearch />
            <FilterButton />
          </View>
        )}

        <View style={{ height: '85%', marginHorizontal: 12 }}>
          <BusinessList webMap={webMap} />
        </View>
      </View>
      <View style={{ width: '75%', height: '100%' }}>
        <WebMap webMap={webMap} setWebMap={setWebMap} />
      </View>
      <View style={{ position: 'absolute', top: 50, right: 50 }}>
        <AddBusinessButton />
      </View>
      <View style={{ position: 'absolute', top: 100, right: 47 }}>
        <CurrentLocationButton webMap={webMap} />
      </View>
      <AddBusinessModal />
      <EditBusinessModal />
    </View>
  );
}
